import ManageLeaveCredit from 'module/leave/pages/adminLeaveSetting/view/manageLeaveCredit'
import ManageLeavePolicy from 'module/leave/pages/adminLeaveSetting/view/manageLeavePolicy'
import ManageOperationDay from 'module/leave/pages/adminLeaveSetting/view/manageOperationDay'
import CustomHolidayForm from 'module/leave/pages/editOperationDays/components/CustomHolidayForm'
import EditOperationDay from 'module/leave/pages/editOperationDays/view'
import LeaveAllocationImport from 'module/leave/pages/leaveAllocationImport/view'
import LeaveAllocationTable from 'module/leave/pages/leaveAllocationImport/view/LeaveAllocationTable'
import LeaveDetailsRequirementsImport from 'module/leave/pages/leaveDetailsRequirementImport/view'
import LeaveDetailsTable from 'module/leave/pages/leaveDetailsRequirementImport/view/LeaveDetailsTable'
import ImportPayrollData from 'module/payroll/pages/payroll-configuration/components/ImportPayrollData'
import PreviewPayrollImport from 'module/payroll/pages/payroll-configuration/components/PreviewPayrollImport'
import EditAllStaff from 'module/staff-management/pages/EditAllStaff'
import InviteMultipleStaff from 'module/staff-management/pages/InviteMultipleStaff'
import InviteStaff from 'module/staff-management/pages/InviteStaff'
import ManageEmployeeFile from 'module/staff-management/pages/ManageEmployeeFile'
import MultipleStaffTable from 'module/staff-management/pages/MultipleStaffTable'
import ReinviteStaff from 'module/staff-management/pages/ReinviteStaff'
import RehireEmployee from 'module/staff-management/pages/RehireEmployee'
import TerminateEmployee from 'module/staff-management/pages/TerminateEmployee'
import CompanyManagementRoutes from 'pages/company-management/routes'
import StaffManagement from 'pages/staff-management/view/staffManagement'
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom'

const OrganizationalAdminRoutes = () => {
  const location = useLocation()
  const state = location.state
  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route path="company-management/*" element={<CompanyManagementRoutes />} />
        <Route path="staff-management" element={<Outlet />}>
          <Route index element={<Navigate to="employee-file" />} />
          <Route path="employee-file" element={<StaffManagement initialTab={0} />} />
          <Route path="employee-file" element={<Outlet />}>
            <Route path=":id" element={<ManageEmployeeFile />} />
          </Route>
          <Route path="organization-chart" element={<StaffManagement initialTab={1} />} />
        </Route>
      </Routes>
      {state?.backgroundLocation && (
        <Routes>
          <Route path="staff-management/employee-file" element={<Outlet />}>
            <Route path="invite-staff" element={<InviteStaff />} />
            <Route path="invite-multiple-staff" element={<InviteMultipleStaff />} />
            <Route path="invite-multiple-staff" element={<Outlet />}>
              <Route path="import" element={<MultipleStaffTable state={state} />} />
            </Route>
            <Route path="reinvite-staff" element={<ReinviteStaff />} />
            <Route path=":id" element={<ManageEmployeeFile />} />
            <Route path=":id" element={<Outlet />}>
              <Route path="edit-all/:id" element={<EditAllStaff />} />
              <Route
                path="terminate"
                element={<TerminateEmployee staff={state.employee} employeeID={state.employeeID} />}
              />
              <Route
                path="rehire"
                element={<RehireEmployee staff={state.employee} employeeID={state.employeeID} />}
              />
            </Route>
          </Route>

          {/* TODO  NEWW, CHECK THIS LATER AFTER PITCHING */}
          <Route path="company-management/leave" element={<Outlet />}>
            <Route path="operation-day" element={<ManageOperationDay />} />
            <Route path="edit-operation-day" element={<EditOperationDay />}>
              <Route path="create-custom-holiday" element={<CustomHolidayForm />} />
            </Route>

            <Route path={`:id`} element={<ManageLeavePolicy state={state} />} />
            <Route path="leave-credit-policy" element={<ManageLeaveCredit />} />
            <Route path="leave-allocation" element={<LeaveAllocationImport state={state} />} />

            <Route path="leave-allocation" element={<Outlet />}>
              <Route path="import" element={<LeaveAllocationTable state={state} />} />
            </Route>
            <Route
              path="leave-details"
              element={<LeaveDetailsRequirementsImport state={state} />}
            />
            <Route path="leave-details" element={<Outlet />}>
              <Route path="import" element={<LeaveDetailsTable state={state} />} />
            </Route>
          </Route>
          <Route path="company-management/payroll" element={<Outlet />}>
            <Route path="import-payroll" element={<ImportPayrollData state={state} />} />
            <Route path="import-payroll" element={<Outlet />}>
              <Route path="import" element={<PreviewPayrollImport state={state} />} />
            </Route>
          </Route>
        </Routes>
      )}
    </>
  )
}
export default OrganizationalAdminRoutes
